.organisation-card {
  background: var(--card, #{$color-white}); /* dark: #09090B */
  color: var(--card-foreground, inherit);
  border: 1px solid var(--border, transparent); /* dark: #27272A */
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(16, 30, 54, 0.08);
  padding: 24px;
  margin-bottom: 24px;

  &__body {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 95px;
  }

  &__left {
    flex: 1;
    min-width: 220px;
    max-width: 340px;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
    color: var(--text-heading, #{$color-black});
  }

  &__description {
    color: var(--text-paragraph-2, #3F3F46);
    font-size: 14px;
  }

  &__right {
    flex: 2;
    min-width: 320px;
  }
}

.dark .organisation-card {
  box-shadow: none;
}
